export default __webpack_public_path__ + "static/media/view-calendar.7598df7f.svg";